var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7L10.6411 6.03988C10.8796 6.01337 11.1204 6.01337 11.3589 6.03988L20 7V16.75C20 18.5449 18.5449 20 16.75 20H5.25C3.45508 20 2 18.5449 2 16.75V7Z",
    fill: "url(#paint0_linear_1_520)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.25C2 3.45507 3.45507 2 5.25 2H16.75C18.5449 2 20 3.45507 20 5.25V7H2V5.25Z",
    fill: "url(#paint1_linear_1_520)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1_520)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 9.5C6.05964 9.5 5.5 10.0596 5.5 10.75C5.5 11.4404 6.05964 12 6.75 12C7.44036 12 8 11.4404 8 10.75C8 10.0596 7.44036 9.5 6.75 9.5ZM6.75 13.5C6.05964 13.5 5.5 14.0596 5.5 14.75C5.5 15.4404 6.05964 16 6.75 16C7.44036 16 8 15.4404 8 14.75C8 14.0596 7.44036 13.5 6.75 13.5ZM9.75 10.75C9.75 10.0596 10.3096 9.5 11 9.5C11.6904 9.5 12.25 10.0596 12.25 10.75C12.25 11.4404 11.6904 12 11 12C10.3096 12 9.75 11.4404 9.75 10.75ZM11 13.5C10.3096 13.5 9.75 14.0596 9.75 14.75C9.75 15.4404 10.3096 16 11 16C11.6904 16 12.25 15.4404 12.25 14.75C12.25 14.0596 11.6904 13.5 11 13.5ZM14 10.75C14 10.0596 14.5596 9.5 15.25 9.5C15.9404 9.5 16.5 10.0596 16.5 10.75C16.5 11.4404 15.9404 12 15.25 12C14.5596 12 14 11.4404 14 10.75Z",
    fill: "url(#paint2_linear_1_520)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1_520",
    x: 4.83333,
    y: 9.16667,
    width: 12.3333,
    height: 7.83333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.333333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.333333
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0156863 0 0 0 0 0.286275 0 0 0 0 0.811765 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_520"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.0666667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0333333
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0156863 0 0 0 0 0.286275 0 0 0 0 0.811765 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1_520",
    result: "effect2_dropShadow_1_520"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1_520",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_520",
    x1: 11,
    y1: 20,
    x2: 11,
    y2: 8.33333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0091EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DCBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_520",
    x1: 10.3571,
    y1: -0.25,
    x2: 20.6552,
    y2: 12.9904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_520",
    x1: 11,
    y1: 9.5,
    x2: 11,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDF2FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.dc7832a04394c9606ce80b4d534e120f.svg";
export { ForwardRef as ReactComponent };